import { Form, Input, Table } from "antd";
import React, { FC } from "react";

import {
  ruleRequired,
  ruleText,
} from "../../../../../../../constants/rules/RulesConstantsForms";
import { CreditworthinessEstablishedRating } from "../../../../../../../store/types/scoring.type";

interface IEstablishedRatingTableProps {
  dataSource: CreditworthinessEstablishedRating[];
}

// Таблица "Установленный рейтинг организации"
export const EstablishedRatingTable: FC<IEstablishedRatingTableProps> = ({
  dataSource,
}) => {
  const TABLE_NAME = "creditworthinessResults";
  const columns = [
    {
      title: "№",
      dataIndex: "key",
      render: (
        value: string,
        _record: CreditworthinessEstablishedRating,
        index: number
      ) => (
        <Form.Item
          style={{ margin: 0, width: "100%", padding: 0 }}
          name={[TABLE_NAME, index, "key"]}
          noStyle
        >
          {value}
        </Form.Item>
      ),
    },
    {
      title: "Показатель",
      dataIndex: "title",
      width: "60%",
      render: (
        value: string,
        _record: CreditworthinessEstablishedRating,
        index: number
      ) => (
        <Form.Item
          style={{ margin: 0, width: "100%", padding: 0 }}
          name={[TABLE_NAME, index, "title"]}
          noStyle
        >
          {value}
        </Form.Item>
      ),
    },
    {
      title: "Значение",
      dataIndex: "value",
      width: "30%",
      render: (
        _value: string,
        _row: CreditworthinessEstablishedRating,
        index: number
      ) => (
        <>
          <Form.Item
            style={{ margin: 0, width: "100%", padding: 0 }}
            name={[TABLE_NAME, index, "value"]}
            rules={[ruleText, ruleRequired]}
          >
            <Input />
          </Form.Item>
        </>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      bordered
      pagination={false}
    />
  );
};
